/**
 * Route guard global del paywall (fin de trial sin pago).
 *
 * Si la suscripción está vencida (`isExpired` de SubscriptionContext: status
 * 'expired' o un 402 SUBSCRIPTION_EXPIRED), cualquier ruta privada que no esté
 * en EXPIRED_ALLOWED_PATHS redirige a /subscription/expired. Usa <Navigate>
 * (respeta el basename del router), nunca window.location.href.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';
import { getExpiredRedirect } from '../utils/subscriptionStatus';

function SubscriptionExpiredGuard({ children }) {
  const location = useLocation();
  const { isExpired } = useSubscription();
  const redirect = getExpiredRedirect(location.pathname, isExpired);
  if (redirect) {
    return <Navigate to={redirect} replace state={{ from: location.pathname }} />;
  }
  return children;
}

export default SubscriptionExpiredGuard;
